<p-toast></p-toast>
<p-fieldset legend="Progress" [toggleable]="true">
  <app-training-plan-progress [myEmployeesTab]="true">
  </app-training-plan-progress
></p-fieldset>
<br />

<p-fieldset legend="Training Requirements" [toggleable]="true">
  <div>
    <app-training-plan-panel-list
      [puid]="selectedPuid"
      [enableSelection]="true"
      [enableShowAll]="true"
      (selectionChanged)="onSelectionChanged($event)"
    ></app-training-plan-panel-list>
  </div>

  <div class="button-container" *ngIf="selectedPuid && selectedPuid !== ''">
    <p-splitButton label="Core/Elective" appendTo="body" [model]="coreElectiveItems" [disabled]="disableSplitButton"></p-splitButton>
    <p-splitButton label="Status" appendTo="body" [model]="statusItems" [disabled]="disableSplitButton"></p-splitButton>
    <p-splitButton label="Training Status" appendTo="body" [model]="trainingStatusItems" [disabled]="disableSplitButton"></p-splitButton>
    <p-button appPreventDoubleClick label="{{ unAssignTrainingItemGroupBtnLabel }}" type="submit"
        id="unAssignTrainingItemGroupsBtn" (debounceClick)="openUnAssignTrainingItemGroupSlider()">
    </p-button>

  </div>

  <app-dialog *ngIf="showRevocationReasonOnClickRevokeButtonBtn" 
[reasonValidationMessage]="validationMessageForReasonForTrainingRevocation"
[heading]="headingForTrainingItemRevocation"
(saveDocumentwithReason)="updateRevocationReasonOnRevokingTraining($event)" 
(isModelOpen)="closeReasonDailog($event)">  
</app-dialog>

</p-fieldset>
  <app-unassign-training-item-group-slider
    *ngIf="isUnAssignTrainingItemGroupSliderOpen"
    [isUnAssignTrainingItemGroupSliderOpen]="isUnAssignTrainingItemGroupSliderOpen"
    (isUnAssignTrainingItemGroupSliderActive)="closeUnAssignTrainingItemGroupSlider($event)"
    (refreshOnUnAssignTrainingItemGroups)="refreshTrainingPlanOnUnAssignTrainingItemGroups($event)"
    [trainingItemGroups]="trainingItemGroups"
  (selectedTrainingItemGroupsList)="selectedTrainingItemGroupsList($event)"
  (unassignTrainingItemGroups)="unAssignTrainingItemGroupsFromTrainingPlan()"
  ></app-unassign-training-item-group-slider>
